import { call, put, takeEvery } from 'redux-saga/effects'
import * as orderActions from '@redux/ducks/orderDucks'
import * as orderApi from '@api/orderApi'

interface FetchSaga {
  type: string
  payload: string
}

interface FetchListOrderSaga {
  type: string
  payload: string | { queryStr: string; allBranch?: boolean }
}

function* fetchListOrder({ payload }: FetchListOrderSaga) {
  const queryString = typeof payload === 'string' ? payload : payload.queryStr
  const useAllBranch = typeof payload === 'object' && Boolean(payload?.allBranch)
  try {
    const apiFn = useAllBranch ? orderApi.getListOrderAllBranch : orderApi.getListOrder
    const res: ReturnType<typeof orderApi.getListOrder> = yield call(apiFn, queryString)
    yield put(orderActions.getListOrderSuccess(res))
  } catch (error) {
    yield put(orderActions.getListOrderFail(error))
  }
}

function* fetchListOrderPick({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListOrderPick> = yield call(orderApi.getListOrderPick, queryString)
    yield put(orderActions.getListOrderPickSuccess(res))
  } catch (error) {
    yield put(orderActions.getListOrderPickFail(error))
  }
}

function* fetchListOrderCheck({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListOrderCheck> = yield call(orderApi.getListOrderCheck, queryString)
    yield put(orderActions.getListOrderCheckSuccess(res))
  } catch (error) {
    yield put(orderActions.getListOrderCheckFail(error))
  }
}

function* fetchListOrderPack({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListOrderPack> = yield call(orderApi.getListOrderPack, queryString)
    yield put(orderActions.getListOrderPackSuccess(res))
  } catch (error) {
    yield put(orderActions.getListOrderPackFail(error))
  }
}

function* fetchListOrderSchedule({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListOrderSchedule> = yield call(orderApi.getListOrderSchedule, queryString)
    yield put(orderActions.getListOrderScheduleSuccess(res))
  } catch (error) {
    yield put(orderActions.getListOrderScheduleFail(error))
  }
}

function* fetchListOrderShip({ payload: queryString }: FetchSaga) {
  try {
    const res: ReturnType<typeof orderApi.getListOrderShip> = yield call(orderApi.getListOrderShip, queryString)
    yield put(orderActions.getListOrderShipSuccess(res))
  } catch (error) {
    yield put(orderActions.getListOrderShipFail(error))
  }
}



export default function* watchOrder() {
  yield takeEvery(orderActions.getListOrder.toString(), fetchListOrder)
  yield takeEvery(orderActions.getListOrderPick.toString(), fetchListOrderPick)
  yield takeEvery(orderActions.getListOrderCheck.toString(), fetchListOrderCheck)
  yield takeEvery(orderActions.getListOrderPack.toString(), fetchListOrderPack)
  yield takeEvery(orderActions.getListOrderSchedule.toString(), fetchListOrderSchedule)
  yield takeEvery(orderActions.getListOrderShip.toString(), fetchListOrderShip)
}
